import validator from 'validator';
import { configure } from 'vee-validate';
import { addMethod, setLocale, string } from 'yup';

export default defineNuxtPlugin(async (_nuxtApp) => {
  // Default values
  configure({
    validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
    validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
    validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
    validateOnModelUpdate: false, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
  });

  setLocale({
    boolean: {
      isTrue: 'Dieses Feld muss bestätigt werden.',
    },
    date: {
      min: 'Das Datum muss nach dem ${min} liegen.',
    },
    mixed: {
      default: 'Dieses Feld ist ungültig.',
      notType: 'Dieses Feld ist ungültig.',
      required: 'Dieses Feld ist erforderlich.',
    },
    string: {
      email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      min: 'Dieses Feld muss mindestens ${min} Zeichen lang sein.',
    },
  });

  // Custom validation rules
  // https://github.com/jquense/yup?tab=readme-ov-file#addmethodschematype-schema-name-string-method--schema-void
  addMethod(string, 'url', function () {
    /* eslint-disable */
    return this.test('is-url', 'Bitte geben Sie eine gültige URL ein.', (value) =>
      value
        ? validator.isURL(value, {
            protocols: ['http', 'https'],
            require_protocol: false,
            require_tld: true,
          })
        : true,
    );
    /* eslint-enable */
  });

  addMethod(string, 'zip', function () {
    // eslint-disable-next-line @typescript-eslint/no-invalid-this
    return this.test('is-zip', 'Bitte geben Sie eine gültige Postleitzahl ein.', (value) => validator.isPostalCode(value!, 'DE'));
  });

  addMethod(string, 'mobilePhone', function () {
    // eslint-disable-next-line @typescript-eslint/no-invalid-this
    return this.test('is-mobile-phone', 'Bitte geben Sie eine gültige Telefonnummer ein.', (value) => validator.isMobilePhone(value!, 'de-DE'));
  });
});
